import React, { useRef, useLayoutEffect } from "react";
import "./styles.css";
const rectContainsRect = (parent, child) => {
    return (child.top >= parent.top &&
        child.bottom <= parent.bottom &&
        child.left >= parent.left &&
        child.right <= parent.right);
};
const TruncatedList = ({ renderTruncator, alwaysShowTruncator, children, className, style, }) => {
    const containerRef = useRef(null);
    useLayoutEffect(() => {
        const truncate = () => {
            if (!containerRef.current) {
                return;
            }
            containerRef.current.style.overflow = "hidden";
            const childNodes = Array.from(containerRef.current.children);
            // Show all items, hide all truncators.
            for (let i = 0; i < childNodes.length; ++i) {
                childNodes[i].hidden = i % 2 === 0;
            }
            // If there are no items (the last truncator is always included).
            if (childNodes.length === 1) {
                return;
            }
            //
            // Test if truncation is necessary.
            //
            if (alwaysShowTruncator) {
                // if the last truncator fits, exit
                const truncatorEl = childNodes[childNodes.length - 1];
                truncatorEl.hidden = false;
                if (rectContainsRect(containerRef.current.getBoundingClientRect(), truncatorEl.getBoundingClientRect())) {
                    return;
                }
                truncatorEl.hidden = true;
            }
            else {
                // if the last item fits, exit
                const itemEl = childNodes[childNodes.length - 2];
                if (rectContainsRect(containerRef.current.getBoundingClientRect(), itemEl.getBoundingClientRect())) {
                    return;
                }
            }
            //
            // Go backward and find the last truncator that can fit.
            //
            for (let i = childNodes.length - 2; i >= 1; i -= 2) {
                const itemEl = childNodes[i];
                const truncatorEl = childNodes[i - 1];
                itemEl.hidden = true;
                truncatorEl.hidden = false;
                if (rectContainsRect(containerRef.current.getBoundingClientRect(), truncatorEl.getBoundingClientRect())) {
                    return;
                }
                truncatorEl.hidden = true;
            }
        };
        truncate();
        const resizeObserver = new ResizeObserver((entries) => {
            for (let _ of entries) {
                truncate();
            }
        });
        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }
        return () => {
            if (containerRef.current) {
                resizeObserver.unobserve(containerRef.current);
            }
        };
    }, [children, alwaysShowTruncator, className, style]);
    const childArray = React.Children.toArray(children);
    const items = childArray.map((item, i) => (React.createElement(React.Fragment, { key: i },
        React.createElement("li", { hidden: true }, renderTruncator({ hiddenItemsCount: childArray.length - i })),
        React.createElement("li", null, item))));
    return (React.createElement("ul", { ref: containerRef, className: `react-truncate-list ${className || ""}`, style: style },
        items,
        React.createElement("li", { hidden: true }, renderTruncator({ hiddenItemsCount: 0 }))));
};
export default TruncatedList;
